import { Sheet } from "twind";
import { Options, setup, STYLE_ELEMENT_ID } from "./shared.ts";

type State = [string, string][];

export default function hydrate(options: Options, state: State) {
  const el = document.getElementById(STYLE_ELEMENT_ID) as HTMLStyleElement;
  const rules = new Set<string>();
  const precedences: number[] = [];
  const mappings = new Map(
    state.map((v) => typeof v === "string" ? [v, v] : v),
  );
  // deno-lint-ignore no-explicit-any
  const sheetState: any[] = [precedences, rules, mappings, true];
  const target = el.sheet!;
  const ruleText = Array.from(target.cssRules).map((r) => r.cssText);
  for (const r of ruleText) {
    const m = r.lastIndexOf("/*");
    const precedence = parseInt(r.slice(m + 2, -2), 36);
    const rule = r.slice(0, m);
    rules.add(rule);
    precedences.push(precedence);
  }
  const sheet: Sheet = {
    target,
    insert: (rule, index) => target.insertRule(rule, index),
    init: (cb) => cb(sheetState.shift()),
  };
  setup(options, sheet);
}

// denoCacheMetadata={"headers":{"content-security-policy":"default-src 'none'; style-src 'unsafe-inline'; sandbox","cross-origin-opener-policy":"same-origin","vary":"Accept-Encoding, Origin","via":"http/2 edgeproxy-h","referrer-policy":"strict-origin-when-cross-origin","x-amz-cf-id":"4uo3H9cViLgPmBTHsPTcDLhLC4WRpuOdZODFKvrQrA-gX_dDF6JH1g==","x-amz-cf-pop":"IAD61-P1","etag":"\"e835cdf2adf3d06eb24db09bac09265c\"","cache-control":"public, max-age=31536000, immutable","x-amz-replication-status":"COMPLETED","x-amz-version-id":"PF._JfMs9aUeriDntpPnNPf7yBoarUAH","x-amz-server-side-encryption":"AES256","x-cache":"Hit from cloudfront","accept-ranges":"bytes","server":"deno/gcp-us-east4","content-length":"1021","x-frame-options":"DENY","x-content-type-options":"nosniff","content-type":"application/typescript; charset=utf-8","cross-origin-resource-policy":"same-origin","date":"Wed, 25 Dec 2024 17:08:08 GMT","last-modified":"Thu, 17 Aug 2023 16:08:00 GMT","access-control-allow-origin":"*","cross-origin-embedder-policy":"same-origin","server-timing":"fetchSource;dur=8","strict-transport-security":"max-age=63072000; includeSubDomains; preload","age":"23072294"},"url":"https://deno.land/x/fresh@1.4.2/plugins/twind/main.ts","time":1758218781}